var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1678,
    height: 2048,
    viewBox: "-280 0.5 1678 2048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F9F9FA",
    enableBackground: "new    ",
    d: "M1392.829,218.126c10.15-15.24,5.07-35.559-12.69-40.639 L827.999-0.022h-1108V2048.5h210.623L1080.697,604.196l119.269-149.856l106.583-132.077L1392.829,218.126z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1313.439,224.791c8.95-13.44,4.471-31.359-11.189-35.839L714.633-0.011H-280V2048.5h141.852 L1143.401,433.104l93.968-116.476L1313.439,224.791z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.8fabb59fa5d21607c16ae2710ad92257.svg";
export { ForwardRef as ReactComponent };